export default __webpack_public_path__ + "static/media/logomin.3710e18b.svg";